import { render, staticRenderFns } from "./ContentBlock.vue?vue&type=template&id=112e0958&"
import script from "./ContentBlock.js?vue&type=script&lang=js&"
export * from "./ContentBlock.js?vue&type=script&lang=js&"
import style0 from "./ContentBlock.scss?vue&type=style&index=0&prod&lang=scss&module=true&"
import style1 from "./cookieTable.scss?vue&type=style&index=1&prod&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports